import { render, staticRenderFns } from "./CanvasDialog.vue?vue&type=template&id=f17c2c4e&scoped=true&"
import script from "./CanvasDialog.vue?vue&type=script&lang=js&"
export * from "./CanvasDialog.vue?vue&type=script&lang=js&"
import style0 from "./CanvasDialog.vue?vue&type=style&index=0&id=f17c2c4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17c2c4e",
  null
  
)

export default component.exports